var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteFancyCornerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9842 11.2998L13.9561 0.478049L3.13434 0.449969C3.02159 0.434704 2.90688 0.443841 2.79798 0.476763C2.68907 0.509684 2.5885 0.565621 2.50309 0.640787C2.41768 0.715951 2.34942 0.80859 2.30293 0.912431C2.25643 1.01627 2.23279 1.12889 2.2336 1.24266C2.23441 1.35643 2.25966 1.4687 2.30764 1.57187C2.35561 1.67504 2.42519 1.76669 2.51166 1.84063C2.59814 1.91456 2.69949 1.96906 2.80886 2.00042C2.91823 2.03178 3.03305 2.03928 3.14557 2.02241L11.2549 2.0561L0.511739 12.7992C0.362798 12.9482 0.279124 13.1502 0.279123 13.3608C0.279123 13.5714 0.362797 13.7734 0.511739 13.9224C0.66068 14.0713 0.86269 14.155 1.07332 14.155C1.28396 14.155 1.48597 14.0713 1.63491 13.9224L12.378 3.17927L12.4117 11.2886C12.4125 11.4993 12.4969 11.7011 12.6464 11.8496C12.796 11.9981 12.9984 12.0811 13.2092 12.0804C13.4199 12.0796 13.6217 11.9952 13.7702 11.8457C13.9187 11.6961 14.0017 11.4937 14.001 11.2829L13.9842 11.2998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFancyCornerIcon);
export default __webpack_public_path__ + "static/media/white-fancy-corner-icon.4db65e1765696f309d05f44ddecfc2c4.svg";
export { ForwardRef as ReactComponent };